import { DeploymentUnitOutlined } from "@ant-design/icons";
import { t } from "../../../languages";
import { capitalizeFirstLetter } from "../../../utils";
import { Avatar, Button } from "antd";
import { AGE } from "../../../modules/user";

// Begging -> competition data
const CompetitionStage1 = ({ lang, theCompetition, theClass, handleOpenCompetition }) => {
    return <>
        <div className="create-class-code">
            {theClass ? <h2><Avatar src={`./static/ages/age_${theClass.age}.svg`} /> {AGE[theClass.age]}</h2> : null}
            <h3>{t(lang, 'classcode')}:</h3>
            <h2 className='code'>{theClass.code}</h2>
            <br />
            <p>
                {t(lang, 'readytoopen')}
            </p>

        </div>
        <div className="students-list">
            <h3>{capitalizeFirstLetter(t(lang, 'challenges'))}:</h3>
            <ul>
                {theCompetition.exercises.map(aE => <li key={`${aE.label}-${aE.level}`}>{t(lang, 'level')} {aE.level} - {t(lang, aE.label)}</li>)}
            </ul>
        </div>
        <div>
            <Button type="primary" className="button-blue" onClick={handleOpenCompetition}>
                <DeploymentUnitOutlined /> {t(lang, 'open')}
            </Button>
        </div>
    </>;
}

export default CompetitionStage1;